import React from "react";

import Section from "../../layout/Section/Section";
import Container from "../../layout/Container/Container";
import TextTitle from "../../base/Text/TextTitle/TextTitle";
import Spacer from "../../layout/Spacer/Spacer";
import HorizontalIconTextList from "../../feature/HorizontalIconTextList/HorizontalIconTextList";
import Button from "../../base/Button/Button";
import { legacySizeCollectionMap } from "../../base/Text/Text.map";
import Text from "../../base/Text/Text";

const SectionOurPromise = () => (
  <Section component={SectionOurPromise.name} theme="light" size="none">
    <Container>
      <div className="mb-4 md:mb-8 relative px-2">
        <Text tag={"h2"} display="title" size={legacySizeCollectionMap.titleLg} align="center"
          className="hidden md:block"> Our Promise To You</Text>
        <TextTitle size={1} align="center" className="block md:hidden">Our Promise To You</TextTitle>
      </div>
      <Spacer size="lg" />
      <HorizontalIconTextList
        listTag="ul"
        items={[
          {
            icon: "catBenefitShinyCoat",
            title: "Health benefits you can see",
            body: "95% of cat people say their cat is happier and healthier after switching to KatKin.",
          },
          {
            icon: "padlockUnlocked",
            title: "Manage your deliveries with complete flexibility",
            body: "Change your mix of recipes easily, or cancel altogether - and no surprise charges, ever.",
          },
          {
            icon: "phone",
            title: "Customer love guaranteed",
            body: <>Get answers, advice and even speak to a vet.
              Call us 7 days a week on <a href="tel:02045384144">0204 538 4144</a> or
              email <a href="mailto:meow@katkin.com">meow@katkin.com</a></>,
          },
        ]}
      />

      <Spacer size="lg" />
      <div className="md:flex md:justify-center">
        <Button
          to="/forms/fresh-feast-trial"
          className="md:!w-auto"
        >
            Build their starter box
        </Button>
      </div>
    </Container>
  </Section>
);

export default SectionOurPromise;
